export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        protocolFormIsOpen: false,
        protocolGridIsOpen: false,
        
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új expozíció',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            },
            {
                btn_text: '<i class="fas fa-tasks"></i>',
                title: 'Protokoll felvitele',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'addProtocolToExposure'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "description",
                label: "Leírás",
                visibility: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "createdBy",
                label: "createdBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "createdOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                sort: true,
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],

        protocolDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        protocolActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning",
                event_payload: 'backToExposureGrid'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új protokoll',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'newProtocolRow'
            }
        ],
        protocolFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning",
                event_payload: 'backToProtocolGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetProtocolForm'
            }
        ],
        protocolRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyProtocolRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteProtocolRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteProtocolRow'
            }
        ],
        protocolHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                formRequired: true,
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "frequency",
                label: "Gyakoriság",
                formType: "text",
                formSize: 2,
                formVisible: true
            },
            {
                name: "protocolText",
                label: "Protokoll",
                formType: "textarea",
                formSize: 12,
                formRequired: true,
                formVisible: true,
                visibility: false
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
                formVisible: false
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                formVisible: false
            }
        ],

        protocolSelectDataTableOptions: {
            checkbox_rows: true
        },
        protocolSelectActions: [
            {
                btn_text: '<i class="fas fa-plus-square"></i> Protokoll csatolás',
                event_name: "protocol-add",
                class: "btn btn-success  my-custom-class",
                event_payload: {
                    msg: "protocol-add"
                }
            }
        ],
        protocolSelectRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Protokoll megtekintése',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'seeProtocolDetails'
            }
        ],
        protocolSelectHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "name",
                label: "Név",
                sort: true,
                visibility: true
            },
            {
                name: "protocolText",
                label: "Protokoll",
                slot_name: "protocol_format",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                formVisible: false
            }
        ]
    }
}
